import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import colors from "../../assets/theme/colors";
import {
  RANGE_PRESET,
  THERAPY_PREP_FILTERS,
} from "../../components/Reports/reportBuilders/dailyCareReportEntryUtils";

const storyTheme = colors.semantic.profileFlow.careStory;

const toDateInputValue = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
};

const ProfileShareTimelineOptions = ({ controls }) => {
  if (!controls) return null;
  return (
    <Stack spacing={1.1} sx={{ px: 1.2, py: 1.15, borderRadius: "16px", bgcolor: storyTheme.primarySoft }}>
      <Typography sx={{ fontSize: "0.86rem", fontWeight: 500, color: storyTheme.text }}>
        Timeline range
      </Typography>
      <Stack direction="row" spacing={0.7} flexWrap="wrap" useFlexGap>
        {[
          [RANGE_PRESET.WEEK, "This week"],
          [RANGE_PRESET.MONTH, "This month"],
          [RANGE_PRESET.CUSTOM, "Custom"],
        ].map(([value, label]) => (
          <Button
            key={value}
            size="small"
            variant={controls.rangePreset === value ? "contained" : "outlined"}
            onClick={() => controls.setRangePreset(value)}
            sx={{ textTransform: "none", borderRadius: 999, fontWeight: 500 }}
          >
            {label}
          </Button>
        ))}
      </Stack>
      {controls.rangePreset === RANGE_PRESET.CUSTOM ? (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={0.8}>
          <TextField
            label="Start date"
            type="date"
            size="small"
            value={toDateInputValue(controls.customStartDate)}
            onChange={(event) => controls.setCustomStartDate(new Date(`${event.target.value}T00:00:00`))}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End date"
            type="date"
            size="small"
            value={toDateInputValue(controls.customEndDate)}
            onChange={(event) => controls.setCustomEndDate(new Date(`${event.target.value}T00:00:00`))}
            InputLabelProps={{ shrink: true }}
          />
        </Stack>
      ) : null}
      <Box>
        <Typography sx={{ mb: 0.35, fontSize: "0.78rem", color: storyTheme.muted }}>
          Categories
        </Typography>
        <Stack direction="row" spacing={0.1} flexWrap="wrap" useFlexGap>
          {THERAPY_PREP_FILTERS.map((filter) => (
            <FormControlLabel
              key={filter.key}
              control={(
                <Checkbox
                  size="small"
                  checked={controls.selectedFilters.includes(filter.key)}
                  onChange={() => controls.toggleFilter(filter.key)}
                />
              )}
              label={filter.label}
              sx={{ mr: 1, "& .MuiFormControlLabel-label": { fontSize: "0.78rem" } }}
            />
          ))}
        </Stack>
      </Box>
      <Typography role="status" sx={{ fontSize: "0.76rem", color: storyTheme.muted }}>
        {controls.status === "loading"
          ? "Loading Timeline activity..."
          : `${controls.lines.length} Timeline item${controls.lines.length === 1 ? "" : "s"} · ${controls.periodLabel}`}
      </Typography>
    </Stack>
  );
};

export default ProfileShareTimelineOptions;
